import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'redux';
import { reduxForm, SubmissionError } from 'redux-form';
import { navigateTo } from 'gatsby-link';
import { translate } from 'react-i18next';
import Form from '../blocks/Form';
import Field from '../fields/Field';
import Label from '../text/Label';
import InputField from '../fields/InputField';
import Actions from '../blocks/Actions';
import Button from '../buttons/Button';
import ActionButton from '../buttons/ActionButton';
import ActionLinkButton from '../links/ActionLinkButton';
import LinkButtonLink from '../links/LinkButtonLink';
import Message from '../text/Message';

class LoginForm extends React.PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    showLabels: PropTypes.bool,
    error: PropTypes.string,
    onCancel: PropTypes.func,
    valid: PropTypes.bool,
  };

  static defaultProps = {
    showLabels: false,
    error: null,
    onCancel: null,
    valid: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  render() {
    const { t, showLabels = false, handleSubmit, error, onCancel, valid } = this.props;
    const { showPassword = false } = this.state;
    return (
      <Form onSubmit={handleSubmit}>
        <Field>
          {showLabels && (<Label>{t('email', {
            defaultValue: 'Email Address',
          })}</Label>)}
          <Field>
            <InputField
              name="email"
              type="text"
              placeholder={t('email_placeholder', {
                defaultValue: 'Enter Email Address',
              })}
            />
          </Field>
        </Field>
        <Field>
          {showLabels && (
            <Label>
              {t('password', {
                defaultValue: 'Password',
              })}
              <ActionLinkButton
                right
                type="button"
                onClick={() => this.setState(() => ({ showPassword: !showPassword }))}
              >{showPassword ? t('hide', 'Hide') : t('show', 'Show')}</ActionLinkButton>
            </Label>
          )}
          <Field>
            <InputField
              name="password"
              type={showPassword ? 'text' : 'password'}
              placeholder={t('password_placeholder', {
                defaultValue: 'Enter Password',
              })}
            />
          </Field>
        </Field>
        <Actions>
          <ActionButton
            bold
            disabled={!valid}
          >Log In</ActionButton>
          {onCancel && (
            <Button
              bold
              type="button"
              disabled={!valid}
              onClick={onCancel}
            >{t('cancel', 'Cancel')}</Button>
          )}
          <LinkButtonLink to="/reset-password">{t('forgot_password', {
            defaultValue: 'Forgot password?',
          })}</LinkButtonLink>
        </Actions>
        {error && (<Message error>{error}</Message>)}
      </Form>
    );
  }
}

export default compose(
  translate(),
  graphql(gql`
    mutation login($email: String!, $password: String!) {
      viewer: createLoginToken(email: $email, password: $password) {
        user {
          _id
          name
        }
        token
      }
    }
  `, {
    name: 'login',
  }),
  reduxForm({
    form: 'LoginForm',
    onSubmit: async (variables, _, { error, login, reset, destroy }) => {
      if (!variables.password || variables.password.length === 0) {
        throw new SubmissionError({
          password: 'Required',
        });
      }
      if (!error) {
        try {
          const { data } = await login({ variables });
          if (data.viewer.token) {
            localStorage.setItem('authToken', data.viewer.token);
            reset();
            destroy();
            navigateTo('/spaces');
          }
        } catch (err) {
          if (err.graphQLErrors) {
            err.graphQLErrors.map(({ message }) => {
              throw new SubmissionError({
                _error: message,
              });
            });
          }
        }
      }
    },
    validate: values => {
      const errors = {};
      if (!values.email) {
        errors.email = 'Required';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
      }
      return errors;
    },
  }),
)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/forms/LoginForm.js